import { InjectionToken } from '@angular/core';
import { AccountFormattingPort } from '../ports/account-formatting.port';

export const ACCOUNT_FORMATTING_PORT = new InjectionToken<AccountFormattingPort>(
  'AccountFormattingPort'
);
